<template>
  <vx-card v-show="isCardActiveLocal" class="mt-3 mb-4" title="Final Summary">
    <div v-if="quizData.quizSettings && quizData.quizSettings.quizType == 'graded'" class="vx-row">
      <div class="flex flex-wrap items-center justify-center">
        <p class="ml-4 mr-2">Final Score: </p>
        <p>{{ totalScore + " / " +  quizData.quizSettings.maxScore}}</p>
      </div>
    </div>
    <div v-if="quizData.finalAssessorComment" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label><strong>{{ viewOnly ? "Teacher Comment:" : "Assessor Comment:" }}</strong></label>
        <vs-textarea readOnly v-model="quizData.finalAssessorComment" />
      </div>
    </div>
    <div v-if="!viewOnly" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label>Your Final Comment:</label>
        <vs-textarea v-model="quizData.finalStudentComment" />
      </div>
    </div>
  </vx-card>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      totalScore: {
        type: Number,
        required: false
      },
      quizData: {
        type: Object,
        required: false
      },
      viewOnly: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          
        }
      }
    },
    mounted() {
      
    },
  }

</script>

<style lang="scss">

</style>
